<template>
    <!-- BEGIN: Content-->
    <div class="productList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Item
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>
        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
                <v-card-title>
                    <h2>Items</h2>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchRes"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
              <v-data-table
                dense
                :headers="fields"
                :items="productsLoad"
                class="elevation-0"
                loading="false"
                loading-text="Loading... Please wait"

                id="virtual-scroll-table"
                v-scroll:#virtual-scroll-table="onScroll"
                item-key="id"
                disable-pagination
                hide-default-footer
              >

              <template
                v-if="start > 0"
                v-slot:body.prepend
              >
                <tr>
                  <td
                    :colspan="fields.length"
                    :style="'padding-top:'+startHeight+'px'"
                  >
                  </td>
                </tr>
              </template>
              <template
                v-if="start + perPage < this.$store.state.products.length"
                v-slot:body.append
              >
                <tr>
                  <td
                    :colspan="fields.length"
                    :style="'padding-top:'+endHeight+'px'"
                  >
                  </td>
                </tr>
              </template>

                <template v-slot:item.#="{ index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.image="{ item }">
                  <img :src="item.image" style="width:70px;padding: 1%;border-radius: 5px;"/><br>
                  <div style="display:flex;flex-direction:row">
                    <img v-for="(thumb,index) in item.thumbnails" :key="index" :src="thumb.image" style="width:50px;padding: 1%;border-radius: 5px;"/>
                  </div>
                </template>
                <template v-slot:item.name="{ item }">
                  {{ item.item_name }}
                </template>
                <template v-slot:item.category="{ item }">
                  {{ item.category }}
                </template>
                <template v-slot:item.subcategory="{ item }">
                  {{ item.subcategory }}
                </template>
                <template v-slot:item.quantity="{ item }">
                  <span v-if="item.current_stock == null">{{ item.quantity }}</span>
                    <span v-if="item.current_stock != null && item.current_stock != 0">{{ item.current_stock }}</span>
                    <span v-if="item.current_stock == 0" style="color:#E3AF00">Out of Stock</span>
                </template>
                <template v-slot:item.price="{ item }">
                  {{ item.price | currency('') }}
                </template>
                <template v-slot:item.cost="{ item }">
                  {{ item.cost | currency('') }}
                </template>
                <template v-slot:item.offer="{ item }">
                  {{ item.offer }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="addStock(item.id)"
                  >
                    mdi-plus
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteq(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="700px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Item</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                  <v-stepper v-model="stepper">
                        <v-stepper-header text>
                            
                            <div class="step" v-for="(step, index) in steps" :key=index>
                                <v-stepper-step
                                    :edit-icon="'mdi-check'"
                                    :complete-icon="'mdi-pencil'"
                                    :step="index + 1"
                                    :complete="(index + 1 ) <= stepper"
                                    :editable="(index + 1) < stepper">{{ step.label }}</v-stepper-step>
                                <v-divider></v-divider>
                            </div>
                            
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <div class="row">
                                    <div class="col-lg-8">
                                      <img :src="previewImage" style="width:30%;"  />
                                    </div>
                                </div>
                                <v-row>
                                  <v-col cols="12" sm="6" md="6">
                                    <v-file-input
                                      :rules="imageRules"
                                      accept="image/png, image/jpeg, image/bmp, image/webp"
                                      prepend-icon="mdi-camera"
                                      label="Select image"
                                      v-on:change="onChange"
                                      id="image" 
                                      name="image"
                                    ></v-file-input>
                                  </v-col>
                                </v-row>
                                <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb1" style="width:30%;"  />
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb2" style="width:30%;"  />
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb3" style="width:30%;"  />
                                  </div>
                              </div>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 1"
                                    v-on:change="onChangeThumb1"
                                    id="thumbnail1" 
                                    name="thumbnail1"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 2"
                                    v-on:change="onChangeThumb2"
                                    id="thumbnail2" 
                                    name="thumbnail2"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 3"
                                    v-on:change="onChangeThumb3"
                                    id="thumbnail3" 
                                    name="thumbnail3"
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Item Name*"
                                      v-model="item.item_name"
                                      required
                                      :rules="fieldRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-autocomplete
                                      :items="subcategories"
                                      label="Select sub category"
                                      v-model="item.subcategory_id"
                                      item-text="name"
                                      item-value="id"
                                      :rules="fieldRules"
                                      :search-input.sync="search"
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-autocomplete
                                      :items="units"
                                      label="Select unit"
                                      v-model="item.unit_id"
                                      item-text="name"
                                      item-value="id"
                                      :rules="fieldRules"
                                      :search-input.sync="searchunit"
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Quantity*"
                                      required
                                      v-model="item.quantity"
                                      :rules="fieldRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Price"
                                      v-model="item.price"
                                      :rules="fieldRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Cost"
                                      v-model="item.cost"
                                      :rules="fieldRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Sku"
                                      v-model="item.sku"
                                      :rules="fieldRules"
                                      :value="timemilliseconds"
                                      readonly
                                    ></v-text-field>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="6"
                                  >
                                    <v-text-field
                                      label="Discount"
                                      v-model="item.offer"
                                    ></v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn text @click.native="stepper = 1">Back</v-btn>
                                        <v-btn text color="primary" style="float:right !important" @click.native="stepper = 2">Continue</v-btn>
                                    </v-col>
                                </v-row>

                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <vue-editor v-model="item.description" />
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn text @click.native="stepper = 1">Back</v-btn>
                                        <v-btn text color="primary" style="float:right !important" @click.native="stepper = 3">Continue</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                              <v-row>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <v-autocomplete
                                      :items="suppliers"
                                      label="Select supplier"
                                      v-model="item.supplier_id"
                                      item-text="name"
                                      item-value="id"
                                      :rules="fieldRules"
                                      :search-input.sync="searchsupplier"
                                    ></v-autocomplete>
                                  </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                        <v-btn text @click.native="stepper = 2">Back</v-btn>
                                        <v-btn color="primary"
                                          style="float:right !important"
                                          text
                                          :loading="loading"
                                          :disabled="!valid"
                                          @click="create"
                                          >Save</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>

              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="700px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Item</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-stepper v-model="stepper">
                        <v-stepper-header text>
                            
                            <div class="step" v-for="(step, index) in steps" :key=index>
                                <v-stepper-step
                                    :edit-icon="'mdi-check'"
                                    :complete-icon="'mdi-pencil'"
                                    :step="index + 1"
                                    :complete="(index + 1 ) <= stepper"
                                    :editable="(index + 1) < stepper">{{ step.label }}</v-stepper-step>
                                <v-divider></v-divider>
                            </div>
                            
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                              <div class="row">
                                  <div class="col-lg-8">
                                    <img :src="updatepreviewImage" style="width:30%;"  />
                                  </div>
                              </div>
                              <v-row>
                                <v-col cols="12" sm="6" md="6">
                                  <v-file-input
                                    :rules="imageRules"
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select image"
                                    v-on:change="onChange"
                                    id="image" 
                                    name="image"
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                              <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb1" style="width:30%;"  />
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb2" style="width:30%;"  />
                                  </div>
                                  <div class="col-lg-4 col-md-4 col-sm-12">
                                    <img :src="previewThumb3" style="width:30%;"  />
                                  </div>
                              </div>
                              <v-row>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 1"
                                    v-on:change="onChangeThumb1"
                                    id="thumbnail1" 
                                    name="thumbnail1"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 2"
                                    v-on:change="onChangeThumb2"
                                    id="thumbnail2" 
                                    name="thumbnail2"
                                  ></v-file-input>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-file-input
                                    accept="image/png, image/jpeg, image/bmp, image/webp"
                                    prepend-icon="mdi-camera"
                                    label="Select thumbnail 3"
                                    v-on:change="onChangeThumb3"
                                    id="thumbnail3" 
                                    name="thumbnail3"
                                  ></v-file-input>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Item Name*"
                                    v-model="item.updateitem_name"
                                    required
                                    :rules="fieldRules"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-autocomplete
                                    :items="subcategories"
                                    label="Select sub category"
                                    v-model="item.updatesubcategory_id"
                                    :value="item.updatesubcategory_id"
                                    item-text="name"
                                    item-value="id"
                                    :rules="fieldRules"
                                    :search-input.sync="search"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-autocomplete
                                    :items="units"
                                    label="Select unit"
                                    v-model="item.updateunit_id"
                                    :value="item.updateunit_id"
                                    item-text="name"
                                    item-value="id"
                                    :rules="fieldRules"
                                    :search-input.sync="searchunit"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Quantity*"
                                    required
                                    v-model="item.updatequantity"
                                    :rules="fieldRules"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Price"
                                    v-model="item.updateprice"
                                    :rules="fieldRules"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Cost"
                                    v-model="item.updatecost"
                                    :rules="fieldRules"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Sku"
                                    v-model="item.updatesku"
                                    :rules="fieldRules"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="6"
                                >
                                  <v-text-field
                                    label="Discount"
                                    v-model="item.updateoffer"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                    <v-col cols="12">
                                        <v-btn text @click.native="stepper = 1">Back</v-btn>
                                        <v-btn text color="primary" style="float:right !important" @click.native="stepper = 2">Continue</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <vue-editor v-model="item.updatedescription" />
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn text @click.native="stepper = 1">Back</v-btn>
                                        <v-btn text color="primary" style="float:right !important" @click.native="stepper = 3">Continue</v-btn>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                              <v-row>
                                <v-col
                                    cols="12"
                                    sm="12"
                                    md="12"
                                  >
                                    <v-autocomplete
                                      :items="suppliers"
                                      label="Select supplier"
                                      v-model="item.updatesupplier_id"
                                      item-text="name"
                                      item-value="id"
                                      :rules="fieldRules"
                                      :search-input.sync="searchsupplier"
                                    ></v-autocomplete>
                                  </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                      <v-btn text @click.native="stepper = 2">Back</v-btn>
                                      <v-btn color="primary"
                                        style="float:right !important"
                                        text
                                        :loading="loading"
                                        :disabled="!valid"
                                        @click="update"
                                        >Save</v-btn>
                                  </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="dark darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

      <!-- add stock modal-->
      <v-dialog
        v-model="addstockdialog"
        width="600px"
        >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Stock</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Item Name*"
                      v-model="item.addstockitem_name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Quantity*"
                      required
                      v-model="item.addstockquantity"
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="dark darken-1"
                text
                @click="addstockdialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="stocktaking"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update stock -->

    </div>

</template>
<style scope>
@media (min-width: 576px){
    .modal-slide-in .modal-dialog {
        width: 48rem;
    }
}
.v-sheet.v-stepper:not(.v-sheet--outlined) {
     box-shadow: none !important; 
}
.vs__selected, .vs__search,.vs__search:focus{
    color: #B4B7BD !important;
}
.vs__open-indicator,.vs__clear{
    fill:  #B4B7BD !important;
}
#virtual-scroll-table {
  max-height: 65vh;
  overflow: auto;
}
/*#virtual-scroll-table {
  max-height: 600px;
  overflow: auto;
}*/
</style>
<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import Pusher from 'pusher-js'
import {ability} from '../../services/ability'

import { VueEditor } from "vue2-editor";

export default {
    name:"productList",
    components: { VueEditor },
    data(){
        return {
          stepper: 1,
          steps: [
              {
                  label: 'Product Information',
                  completed: false,
              },
              {
                  label: 'Product Description',
                  completed: false,
              },
              {
                  label: 'Supplier Details',
                  completed: false,
              },
          ],
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          imageRules: [
            value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
          ],
          searchfilter: '',
          search:null,
          valid: true,
          searchunit:null,
          searchsupplier:null,
          dialog: false,
          updatedialog: false,
          addstockdialog: false,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Products',
              disabled: false,
              href: '',
            },
            {
              text: 'Items',
              disabled: false,
              href: '',
            },
          ],
          fields: [
             {
              text: '#',
              align: 'start',
              value: '#',
            },
            { text: 'Image', value: 'image' },
            { text: 'Name', value: 'name' },
            { text: 'Category', value: 'category' },
            { text: 'Sub Category', value: 'subcategory' },
            { text: 'Quantity', value: 'quantity' },
            { text: 'Price', value: 'price' },
            { text: 'Cost', value: 'cost' },
            { text: 'Discount', value: 'offer' },
            { text: 'Action', value: 'action' },
           ],
           previewImage: null,
           updatepreviewImage: null,
           previewThumb1: null,
           updatepreviewThumb1: null,
           previewThumb2: null,
           updatepreviewThumb2: null,
           previewThumb3: null,
           updatepreviewThumb3: null,
          item:{
              item_name:"",
                subcategory_id:"",
                unit_id:"",
                quantity:"",
                price:"",
                cost:"",
                sku:"",
                offer:"",
                description:"",
              image:null,
              thumbnail1:null,
              thumbnail2:null,
              thumbnail3:null,
              supplier_id: "",

              addstockquantity: "",
              addstockitem_name: "",

              updateitem_name:"",
                updatesubcategory_id:"",
                updateunit_id:"",
                updatequantity:"",
                updateprice:"",
                updatecost:"",
                updatesku:"",
                updateoffer:"",
                updatedescription:"",
                updatesupplier_id: "",

              updateID: "",
              addStockID: "",
              _method:"patch"
          },
          isBusy: false,
          loading: false,
           disabled: false,
            updateModal: null,
            products:[],
          start: 0,
          timeout: null,
          rowHeight: 24,
          perPage: 25,
          searchRes: ""
        }
    },
    beforeMount() {
      if(!ability.can('inventory-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    destroyed () {
      this.$barcodeScanner.destroy()
    },
    serverPrefetch () {
      return this.getProducts()
    },
    mounted(){      
      this.getProducts()
      this.$barcodeScanner.init(this.onBarcodeScanned)
      this.timemilliseconds()
    },
    computed: {
      
      suppliers() {
        return this.$store.state.suppliers
      },
      subcategories() {
        return this.$store.state.subcategories
      },
      units() {
        return this.$store.state.units
      },
      productsLoad() {

        return this.$store.state.products.filter(item => {

        let itemname = item.item_name.toString().toLowerCase()

        let searchTerm = ''
          if(this.searchRes !== '') {
            searchTerm = this.searchRes.toString().toLowerCase()
          }
          return itemname.includes(searchTerm)

        }).slice(this.start, this.perPage+this.start)
      },
      startHeight() {
        return this.start * this.rowHeight - 32;
      },
      endHeight() {
        return this.rowHeight * (this.$store.state.products.length - this.start);
      }
      
    },
    methods:{
      timemilliseconds() {
        let d = new Date();
        let n = d.valueOf();
        this.item.sku = n
      },
    onScroll(e) {
        // debounce if scrolling fast
        this.timeout && clearTimeout(this.timeout);
   
        this.timeout = setTimeout(() => {
          const { scrollTop } = e.target;
          const rows = Math.ceil(scrollTop / this.rowHeight);

          this.start = rows + this.perPage > this.$store.state.products.length ?
            this.$store.state.products.length - this.perPage: rows;

          this.$nextTick(() => {
            e.target.scrollTop = scrollTop;
          });
        }, 20);
      },
    onBarcodeScanned (scn) {
      this.item.barcode = scn
    },
    resetBarcode () {
      let barcode = this.$barcodeScanner.getPreviousCode()
    },
      onChange(e) {
        if(e) {
          this.item.image = e;
          this.previewImage = URL.createObjectURL(this.item.image);
        }
      },
      onChangeThumb1(event) {
        if(event) {
          this.item.thumbnail1 = event
          this.previewThumb1 = URL.createObjectURL(event);
        }
      },
      onChangeThumb2(event) {
        if(event) {
          this.item.thumbnail2 = event
          this.previewThumb2 = URL.createObjectURL(event);
        }
      },
      onChangeThumb3(event) {
        if(event) {
          this.item.thumbnail3 = event
          this.previewThumb3 = URL.createObjectURL(event);
        }
      },
      async getProducts(){
        this.isBusy = true
        await axios.get('/item').then(response=>{
            this.$store.state.products = response.data.products
            this.$store.state.units = response.data.units
            this.$store.state.subcategories = response.data.subcategories
            this.$store.state.categories = response.data.categories
            this.$store.state.suppliers = response.data.suppliers
        }).catch(error=>{
            console.log(error)
        })
    },
      clear () {
          this.$refs.form.reset()
        },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('item_name',this.item.item_name)
            fd.append('subcategory_id',this.item.subcategory_id)
            fd.append('unit_id',this.item.unit_id)
            fd.append('quantity',this.item.quantity)
            fd.append('price',this.item.price)
            fd.append('cost',this.item.cost)
            fd.append('sku',this.item.sku)
            fd.append('offer',this.item.offer)
            fd.append('description',this.item.description)
            fd.append('supplier_id',this.item.supplier_id)
            fd.append('file',this.item.image)
            fd.append('thumbnail1',this.item.thumbnail1)
            fd.append('thumbnail2',this.item.thumbnail2)
            fd.append('thumbnail3',this.item.thumbnail3)

            await axios.post('/item', fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.$toast.success('Item added successfully','Success',{position: 'topRight',timeout: 7000,})
              this.getProducts()
              this.previewImage = null
              this.previewThumb1 = null
              this.previewThumb2 = null
              this.previewThumb3 = null
              this.clear()
              this.timemilliseconds()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
             fd.append('name',this.item.updatename)
             fd.append('registration',this.item.updateregistration)
            fd.append('item_name',this.item.updateitem_name)
            fd.append('subcategory_id',this.item.updatesubcategory_id)
            fd.append('unit_id',this.item.updateunit_id)
            fd.append('quantity',this.item.updatequantity)
            fd.append('price',this.item.updateprice)
            fd.append('cost',this.item.updatecost)
            fd.append('sku',this.item.updatesku)
            fd.append('offer',this.item.updateoffer)
            fd.append('description',this.item.updatedescription)
            fd.append('supplier_id',this.item.updatesupplier_id)
            fd.append('file',this.item.image)
            fd.append('thumbnail1',this.item.thumbnail1)
            fd.append('thumbnail2',this.item.thumbnail2)
            fd.append('thumbnail3',this.item.thumbnail3)

            fd.append('_method',this.item._method)

            await axios.post(`/item/${this.item.updateID}`, fd, config).then(response=>{
              console.log(response)
              this.loading = false
              this.disabled = false
                this.$toast.success('Item updated successfully','Success',{position: 'topRight',timeout: 7000,})
                this.getProducts()
                this.updatedialog = false
              this.previewImage = null
              this.previewThumb1 = null
              this.previewThumb2 = null
              this.previewThumb3 = null
              this.item.updateID = ''
              this.timemilliseconds()
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
        async stocktaking(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('item_name',this.item.addstockitem_name)
            fd.append('quantity',this.item.addstockquantity)

            await axios.post(`/add-stock/${this.item.addStockID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
                this.$toast.success('Stock updated successfully','Success',{position: 'topRight',timeout: 7000,})
                this.getProducts()
                this.addstockdialog = false
              this.clear()
              this.item.addStockID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async edit(id) {
        let index = this.$store.state.products.filter(item => item.id === id );
          this.item.updateitem_name = index[0].item_name
          this.item.updatesubcategory_id = index[0].subcategory_id
          this.item.updateunit_id = index[0].unit_id
          this.item.updatequantity = index[0].quantity
          this.item.updateprice = index[0].price
          this.item.updatecost = index[0].cost
          this.item.updatesku = index[0].sku
          this.item.updateoffer = index[0].offer
          this.item.updatedescription = index[0].description
          this.item.updatesupplier_id = index[0].supplier_id
          this.updatepreviewImage = index[0].image
        this.item.updateID = index[0].id
        this.updatedialog = true
      },
      addStock(id) {
        let index = this.$store.state.products.filter(item => item.id === id );
        this.item.addstockitem_name = index[0].item_name
        this.item.addStockID = index[0].id
        this.addstockdialog = true
    },
      deleteq(id){
            if(confirm("Are you sure to delete item ?")){
                axios.delete(`/item/${id}`).then(response=>{
                  this.$toast.success('Item deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                  this.getProducts()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }
    }
}
</script>